import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './app-config';

@Injectable({
  providedIn: 'root'
})
export class JsonAppConfigService {
  API_URL;
  STAGE;
  constructor(private http: HttpClient) {}
  load() {
    return this.http
      .get<AppConfig>('config.json')
      .toPromise()
      .then(data => {
        console.log(data);
        this.API_URL = data.API_URL;
        this.STAGE = data.STAGE;
      });
  }
}
